// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gqxC","badges":"styles_badges__1ow_7"};